import { Injectable } from '@angular/core';
import { SCREENS } from '@app/shared';

@Injectable({
  providedIn: 'root'
})
export class EnumService {

  SCREENS = SCREENS; 

  constructor() { }
}
